/**
 * Downloads a file from a given URL
 * @param url - The URL of the file to download
 * @param filename - The name to save the file as
 */
export const downloadFile = async (url: string, filename: string): Promise<void> => {
  try {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()

    // Cleanup - remove the link after a short delay
    setTimeout(() => {
      document.body.removeChild(link)
    }, 100)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw error
  }
}
